import { WORDS } from './wordlist'

export const VALID_GUESSES = Array.from(new Set(WORDS))
